@if (canViewDashboard) {
  <sca-dashboard></sca-dashboard>
}
